"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const useClickOutside_1 = __importDefault(require("hooks/useClickOutside"));
const Avatar_1 = __importDefault(require("components/shared/Avatar"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const TourContext_1 = require("src/context/TourContext");
const Button_1 = __importDefault(require("./Button"));
const openAnimation = 'animate-[zoomIn_0.2s]';
const closeAnimation = 'animate-[zoomOut_0.2s_forwards]';
const backdropOpenAnimation = 'animate-[fadeIn_0.2s]';
const backdropCloseAnimation = 'animate-[fadeOut_0.2s_forwards]';
const isEqualProps = (prevProps, nextProps) => {
    return (0, isEqual_1.default)(prevProps, nextProps);
};
const ModalWrapper = react_1.default.memo(({ children }) => {
    const { isClosing, closeOnClickOutside } = (0, exports.useModal)() || {};
    return (react_1.default.createElement("div", { className: `fixed w-screen h-screen top-0 left-0 z-[1001] flex flex-col items-center flex-1
        ${closeOnClickOutside ? 'cursor-pointer' : 'cursor-default'}
        ${!isClosing ? backdropOpenAnimation : backdropCloseAnimation}`, style: { backgroundColor: 'rgba(0,0,0,.5)' }, onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("div", { className: "min-h-[40px] h-[120px]" }),
        children,
        react_1.default.createElement("div", { className: "min-h-[40px]" })));
}, isEqualProps);
const ModalContext = react_1.default.createContext(null);
const useModal = () => react_1.default.useContext(ModalContext);
exports.useModal = useModal;
const Modal = react_1.default.memo(({ minWidth, children, onClose, closeOnClickOutside = true, dataCy, customClass = '', maxWidthClass = 'max-w-[1000px]' }) => {
    const [isClosing, setIsClosing] = (0, react_1.useState)(false);
    const modalRef = (0, react_1.useRef)(null);
    const closeModal = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose && onClose();
        }, 200);
    };
    const { tourStart } = (0, TourContext_1.useTourContext)();
    (0, useClickOutside_1.default)(modalRef, () => {
        !tourStart && closeModal();
    });
    const sharedModal = document.querySelectorAll(`[id^="shared-modal"]`)[0];
    const contextValue = {
        isClosing: isClosing,
        setIsClosing: setIsClosing,
        closeModal: closeModal,
        closeOnClickOutside: closeOnClickOutside
    };
    return react_dom_1.default.createPortal(react_1.default.createElement(ModalContext.Provider, { value: contextValue },
        react_1.default.createElement(ModalWrapper, null,
            react_1.default.createElement("div", { ref: closeOnClickOutside ? modalRef : null, className: `flex flex-col bg-n-000 rounded-[8px] min-h-[0px] flex-initial overflow-hidden cursor-default ${customClass} ${maxWidthClass} ${!isClosing ? openAnimation : closeAnimation}`, style: { minWidth: minWidth || 600 }, "data-cy": dataCy }, children))), sharedModal);
}, isEqualProps);
const Header = ({ title, titleIcon, children, onClose, useBorder, customClass }) => {
    const { closeModal } = (0, exports.useModal)() || {};
    const _onClickClose = () => {
        closeModal && closeModal();
    };
    return (react_1.default.createElement("div", { className: `${customClass
            ? customClass
            : useBorder
                ? 'border-0 border-b border-solid border-n-400'
                : ''} ` }, children ? (children) : (react_1.default.createElement("div", { className: "flex px-[24px] py-[24px] justify-between w-full" },
        react_1.default.createElement("div", { className: "flex" },
            titleIcon?.name && (react_1.default.createElement(SVGIcon_1.default, { iconName: titleIcon?.name, fillColor: titleIcon?.color, onClick: titleIcon?.onClick, size: 24 })),
            react_1.default.createElement("span", { className: `typography-h600 ${titleIcon?.name ? 'ml-[16px]' : ''}` }, title)),
        onClose && (react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-clear", size: 24, fillColor: "var(--n-600)", onClick: _onClickClose }))))));
};
const Body = ({ children, maxHeight, customClass = '' }) => {
    return (react_1.default.createElement("div", { className: `flex flex-initial overflow-y-auto overflow-x-hidden ${customClass}`, style: { maxHeight: `${maxHeight || 480}px` } }, children));
};
const Footer = ({ children, primaryButton, secondaryButton, tertiaryButton, useBorder = true, userInfo, customClass }) => {
    return (react_1.default.createElement("div", { className: `${customClass ? customClass : ''} ${useBorder ? 'border-0 border-t border-solid border-n-400' : ''}` }, children ? (children) : (react_1.default.createElement("div", { className: `flex p-[24px] ${userInfo || tertiaryButton ? 'justify-between' : 'justify-end'}` },
        tertiaryButton && (react_1.default.createElement(Button_1.default.Tertiary, { id: tertiaryButton?.dataCy || 'btn-tertiary', onClick: tertiaryButton.onClick, customClass: "mr-[8px]", disabled: tertiaryButton?.disabled }, tertiaryButton.text)),
        userInfo && (react_1.default.createElement("div", { className: "flex items-center w-[96px]" },
            react_1.default.createElement(Avatar_1.default, { src: userInfo.profilePicture, name: userInfo.name, size: 24, dataCy: userInfo?.dataCy, className: "mx-[8px]" }),
            react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-button text-n-800", useMaxWidth: true }, userInfo.name))),
        react_1.default.createElement("div", { className: "flex" },
            secondaryButton && (react_1.default.createElement(Button_1.default.Secondary, { onClick: secondaryButton.onClick, customClass: "mr-[8px]", datacy: secondaryButton?.dataCy }, secondaryButton.text)),
            primaryButton && (react_1.default.createElement(Button_1.default, { onClick: primaryButton?.onClick, isLoading: primaryButton?.isLoading, variant: primaryButton?.variant, disabled: primaryButton?.disabled, datacy: primaryButton?.dataCy }, primaryButton?.text)))))));
};
Modal.displayName = 'Modal';
ModalWrapper.displayName = 'ModalWrapper';
const ModalWithStatics = Object.assign({}, Modal, {
    Header: Header,
    Body: Body,
    Footer: Footer
});
exports.default = ModalWithStatics;
